<template>
  <div class="notification" :class="[`theme-${theme}`]">
    <div class="badge" ref="badge">
      <img class="icon" :src="icon" v-if="icon" />
      <div class="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'
export default {
  data: () => ({
    text: null,
    icon: null,
    theme: null,
    timer: null
  }),
  created() {
    const animation = this.out()
    animation.seek(animation.duration)
  },
  methods: {
    async notify({ text, theme, icon }) {
      await this.out().finished
      this.text = text
      this.icon = icon
      this.theme = theme
      await this.in().finished
      clearTimeout(this.timer)
      this.timer = setTimeout(this.out, 2000)
    },
    in() {
      return anime({
        targets: this.$refs.badge,
        translateY: [5, 0],
        opacity: [0, 1],
        easing: 'easeInOutQuad',
        duration: 200
      })
    },
    out() {
      return anime({
        targets: this.$refs.badge,
        opacity: 0,
        easing: 'easeInOutQuad',
        duration: 200
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.notification {
  left: 50%;
  position: fixed;
  bottom: var(--spacing-5);
  transform: translateX(-50%);
}
.badge {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 1rem;
  height: 3.2rem;
  padding: 0 var(--spacing-2);
  justify-content: center;
  align-items: center;
  font-weight: var(--fw-medium);
  font-size: 1.4rem;
  border: var(--border-1);
  border-radius: var(--br-1);
  border-color: var(--color-transparent);
}
.theme-white .badge {
  color: var(--color-gray-3);
  background: var(--color-white-1);
}
.theme-green .badge {
  color: var(--color-green-3);
  background: var(--color-green-2);
}
.theme-red .badge {
  color: var(--color-white-1);
  background: var(--color-red-1);
}
.theme-purple .badge {
  color: var(--color-white-1);
  background: var(--color-purple-1);
}
.theme-gray .badge {
  color: var(--color-gray-3);
  background: var(--color-gray-2);
}
.icon {
  height: 1.5rem;
}
</style>
